// Module
var code = "<span data-bind=\"text: feature.name\"></span>\n<input type=\"checkbox\" data-bind=\"checked: isFeatureEnabled\">";
// Exports
module.exports = code;